import React, { useEffect, forwardRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import lineup01 from "/assets/images/2022aug/lineup01.png";
import lineup02 from "/assets/images/2022aug/lineup02.png";
import lineup03 from "/assets/images/2022aug/lineup03.png";
import lineup04 from "/assets/images/2022aug/lineup04.png";
import newColor from "/assets/images/2022aug/newcolor.png";
import palette from "/assets/images/2022aug/palette.png";


import '../styles/LineUp_spNormal.scss'

const LineUp = forwardRef((props, ref) => {

    useEffect(() => {

        gsap.registerPlugin(ScrollTrigger);

        const WrapperEl = document.querySelector('.lineup__scrollWrap');
        const listEl = document.querySelector('.lineup__list');
        const itemEl = document.querySelector('.lineup__item');

        console.log(listEl.clientWidth);
        console.log(WrapperEl.clientWidth);
        console.log(itemEl.clientWidth);

        ScrollTrigger.matchMedia({
            // 768px以上の時のみ横スクロール
            "(min-width: 768px)":() => {
                gsap.to(listEl, {
                    x: () => -(listEl.clientWidth - WrapperEl.clientWidth),
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.lineup',
                        start: 'top top', 
                        end: () => `+=${listEl.clientWidth - WrapperEl.clientWidth}`,
                        // end: "+=100%",
                        scrub: 1,
                        pin: true,
                        pinSpacing: true,
                        anticipatePin: 1,
                        normalizeScroll: true,
                        ignoreMobileResize: true
                        // onToggle: ({isActive}) => {
                        //     gsap.killTweensOf(listEl)
                        //     // gsap.to(mainTitle, {
                        //     //   opacity: isActive ? 1 : 0,
                        //     //   duration: 0.3
                        //     // })
                        // }
                        // invalidateOnRefresh: true,
                        // toggleActions: 'play none none reverse'
                        // markers: true
                    },
                });
            },
            // "(max-width: 767px)":() => {

            // },
        });
        
        // gsap.to(listEl, {
        //     x: () => -(listEl.clientWidth - WrapperEl.clientWidth),
        //     ease: "none",
        //     scrollTrigger: {
        //         trigger: '.lineup',
        //         start: 'top top', 
        //         end: () => `+=${listEl.clientWidth - WrapperEl.clientWidth}`,
        //         // end: "+=100%",
        //         scrub: 1,
        //         pin: true,
        //         pinSpacing: true,
        //         anticipatePin: 1,
        //         normalizeScroll: true,
        //         ignoreMobileResize: true
        //         // onToggle: ({isActive}) => {
        //         //     gsap.killTweensOf(listEl)
        //         //     // gsap.to(mainTitle, {
        //         //     //   opacity: isActive ? 1 : 0,
        //         //     //   duration: 0.3
        //         //     // })
        //         // }
        //         // invalidateOnRefresh: true,
        //         // toggleActions: 'play none none reverse'
        //         // markers: true
        //     },
        // });
            
        

    }, [])

    const lineUpData = [
        {
            src: lineup01,
            caption: "PINK BELLINI",
            alt: "PINK BELLINI",
            className: "first"
        },
        {
            src: lineup02,
            caption: "CARAMEL COCO",
            alt: "CARAMEL COCO",
            className: "second"
        },
        {
            src: lineup04,
            caption: "PINK BELLINI",
            alt: "PINK BELLINI",
            className: "third"
        },
        {
            src: lineup03,
            caption: "MILKY COCO",
            alt: "MILKY COCO",
            className: "fourth"
        },
       
    ]

    return (
        <section className="lineup" ref={ref}>
            <div className="lineup__inner">
                <div className="lineup__scrollWrap">
                    <ul className="lineup__list">
                        {lineUpData.map((data, index) => (
                            <li className="lineup__item" key={index}>
                                <div><img src={data.src} alt={data.alt} width="268" height="400"/></div>
                                <p className={data.className}>{data.caption}</p>
                            </li>
                            )
                        )}
                    </ul>
                </div>
                <div className="lineup__decoration">
                    <div className="lineup__newColor"><img src={newColor} alt="NEW COLOR" width="292" height="294"/></div>
                </div>
            </div>
        </section>
    )
})

export default LineUp